import { router } from '@inertiajs/react';
import Swal from 'sweetalert2';

export function setupInertiaErrorHandling(session?: { lifetime: number }) {
  const handleSessionExpired = () => {
    Swal.fire({
      icon: 'warning',
      title: 'Sesión expirada',
      text: 'Tu sesión ha caducado. Serás redirigido para iniciar sesión de nuevo.',
      timer: 3000,
      timerProgressBar: true,
      allowOutsideClick: false,  // evita cerrar con click fuera
      allowEscapeKey: false,     // evita cerrar con ESC
      allowEnterKey: false,       // evita cerrar con Enter
      didOpen: () => {
        Swal.showLoading();
      },
      willClose: () => {
        router.visit('/login');
      },
    });
  };

  // 🔹 Manejo de errores en peticiones Inertia
  router.on('error', (errors: any) => {
    if (errors?.response?.status === 419) {
      handleSessionExpired();
    }
  });

  router.on('invalid', (event: any) => {
    const response = event.detail?.response;
    if (response?.status === 419) {
      event.preventDefault();
      handleSessionExpired();
    }
  });

  router.on('exception', (event: any) => {
    const err = event.detail?.error;
    const response = err?.response;
    if (response?.status === 419) {
      event.preventDefault();
      handleSessionExpired();
    }
  });

  // 🔹 Control de inactividad en frontend
  if (session?.lifetime) {
    const tiempoMaximoInactividad = session.lifetime * 60 * 1000; // ms
    let timeoutID: number;

    const resetTimer = () => {
      clearTimeout(timeoutID);
      timeoutID = window.setTimeout(handleSessionExpired, tiempoMaximoInactividad);
    };

    document.onmousemove = resetTimer;
    document.onkeypress = resetTimer;
    document.onclick = resetTimer;

    resetTimer(); // arranca
  }
}
